module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm-01"
  }, [_vm._v("When the times change, all men change with them. So many of both the friends and critics of the police talk as if police constables were not men.")]), _vm._v(" "), _c('p', {
    staticClass: "fm-02"
  }, [_c('span', [_vm._v("—"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("WITNESS, ROYAL COMMISSION ON POLICE POWERS")])])]), _vm._v(" "), _c('p', {
    staticClass: "fm-03"
  }, [_vm._v("To the ordinary soldier, the battle is his own small part of the front.")]), _vm._v(" "), _c('p', {
    staticClass: "fm-02"
  }, [_c('span', [_vm._v("—"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("GENERAL GRANT")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-335a713d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frontmatter01.vue
// module id = 75
// module chunks = 0